 const state = () => ({
    isLoading: false,      // 로딩중 여부
});

const getters = {
    getIsLoading: state => state.isLoading,
};

const actions = {
    // 로그인 정보저장
    setLoadingData({commit}, loadingData){
        commit('SET_IS_LOADING', loadingData);
    }
};

const mutations = {
    SET_IS_LOADING(state, payload) {
        state.isLoading = payload;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
